export default __webpack_public_path__ + "img/b7f40f45e09cdd319dbd7f3bf73972ef.svg";